import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Benefits|Program`;

export type CreateLineupLocs =
	| 'CPCreateLineupButton'
	| 'CPCreateLineupSuccessNotification'
	| 'CPCreateLineupFailureNotification';
export const createLineupLocs: LocDefs<CreateLineupLocs> = {
	CPCreateLineupButton: {
		defaultValue: 'Enable Lineup Opt-In',
		description: 'Label for the button to enable creating opt-in (line up)',
		displayPath: `${dpRoot}|Button|Enable Opt-In`,
		displayType: 'Button',
		feature: HubFeature.Benefit,
		portal: 'CP' as LocPortal,
		shared: false,
		htmlAllowed: false,
	},
	CPCreateLineupSuccessNotification: {
		defaultValue: 'Line up created successfully',
		description: 'Notice shown when line up is successfully created',
		displayPath: `${dpRoot}|Notification|Lineup Success`,
		displayType: 'Notification',
		feature: HubFeature.Benefit,
		portal: 'CP' as LocPortal,
		shared: false,
		htmlAllowed: false,
	},
	CPCreateLineupFailureNotification: {
		defaultValue: 'Opt-in enabling failed',
		description: 'Notice shown when line up creation fails',
		displayPath: `${dpRoot}|Notification|Lineup Failure`,
		displayType: 'Notification',
		feature: HubFeature.Benefit,
		portal: 'CP' as LocPortal,
		shared: false,
		htmlAllowed: false,
	},
};

export const LOC_KEYS = MapLocKeys<CreateLineupLocs>(createLineupLocs);
